import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonTitle, IonToolbar, ModalController } from '@ionic/angular/standalone';
import { TranslatePipe, _ } from '@ngx-translate/core';
import { LoaderComponent } from 'src/app/components/loader/loader.component';
import { SizeGuideEditorFormComponent } from 'src/app/components/size-guide-editor-form/size-guide-editor-form.component';
import { SizeGuide } from 'src/app/models/size-guide';
import { SizeGuideService } from 'src/app/services/size-guide.service';
import { ToastService } from 'src/app/services/toast.service';
import { LoadingUtils } from 'src/app/utils/loading.utils';

@Component({
    selector: 'app-size-guide-create-modal',
    standalone: true,
    templateUrl: './size-guide-create-modal.component.html',
    styleUrls: ['./size-guide-create-modal.component.scss'],
    imports: [
        CommonModule,
        TranslatePipe,
        IonHeader,
        IonToolbar,
        IonTitle,
        IonButtons,
        IonButton,
        IonContent,
        IonFooter,
        LoaderComponent,
        SizeGuideEditorFormComponent,
    ],
})
export class SizeGuideCreateModalComponent {
    @Input() existingGuide: SizeGuide | null = null;
    @ViewChild(SizeGuideEditorFormComponent) editor: SizeGuideEditorFormComponent;

    catalogLoading = true;

    constructor(
        private readonly modalCtrl: ModalController,
        private readonly sizeGuideService: SizeGuideService,
        private readonly toastService: ToastService,
    ) {}

    dismiss() {
        this.modalCtrl.dismiss();
    }

    async save() {
        if (!this.editor) {
            return;
        }
        this.editor.markTouched();
        const payload = this.editor.getPayload();
        if (!payload) {
            return;
        }
        await LoadingUtils.show();
        const req = this.existingGuide?.id
            ? this.sizeGuideService.update(this.existingGuide.id, { name: payload.name, guide: payload.guideJson })
            : this.sizeGuideService.create({ name: payload.name, guide: payload.guideJson });
        req.subscribe({
            next: (guide) => {
                LoadingUtils.hide();
                this.modalCtrl.dismiss({ sizeGuide: guide });
            },
            error: () => {
                LoadingUtils.hide();
                this.toastService.error(_('An error occurred'));
            },
        });
    }
}
